import { render, staticRenderFns } from "./AreaRegionSetup.vue?vue&type=template&id=43a65d9e&scoped=true"
import script from "./AreaRegionSetup.vue?vue&type=script&lang=ts"
export * from "./AreaRegionSetup.vue?vue&type=script&lang=ts"
import style0 from "./AreaRegionSetup.vue?vue&type=style&index=0&id=43a65d9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a65d9e",
  null
  
)

export default component.exports